<template>
  <div class="common-layout">
    <el-container class="page-container">
      <!-- 左侧导航栏 -->
      <el-aside width="208px">
        <div class="account-nav">
          <div class="nav-title"><el-text
            size="large"
          >{{ $t('views.account_center.account_center') }}</el-text></div>
          <!-- 菜单项 -->
          <div
            v-for="(menuItem,index) in menuItems"
            :key="index"
            class="nav-item"
            :class="activeMenu===menuItem.value ? 'active' : ''"
            @click="setActiveMenu(menuItem.value)"
          >
            <el-icon
              class="iconfont"
            >
              <User v-show="menuItem.value==='account_set'" />
              <Setting v-show="menuItem.value==='preference_set'" />
              <svg-icon
                v-show="menuItem.value==='subscription_manage'"
                class-name="menu-icon"
                icon-class="crown"
              />
              <Document v-show="menuItem.value==='bill_manage'" />
              <Coin v-show="menuItem.value==='consumption_records'" />
            </el-icon>
            <span class="item-name"><el-text>{{ menuItem.label }}</el-text></span>
          </div>
        </div>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-main :class="{ 'subscription-main': activeMenu === 'subscription_manage' }">
        <div class="main-content">
          <div v-if="activeMenu === 'account_set'">
            <Account_settings />
          </div>
          <div v-else-if="activeMenu === 'preference_set'">
            <Preferences />
          </div>
          <div v-else-if="activeMenu === 'subscription_manage'" class="subscription-wrapper">
            <SubscriptionPurchase embedded
                                  @payment-success="handleSubscriptionPaymentSuccess" />
          </div>
          <div v-else-if="activeMenu === 'bill_manage'">
            <Bill />
          </div>
          <div v-else-if="activeMenu === 'consumption_records'">
            <ConsumptionRecords />
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Bill from './components/bill.vue'
import SubscriptionPurchase from './components/subscription_purchase.vue'
import Account_settings from '@/views/account_center/components/account_settings.vue'
import Preferences from '@/views/account_center/components/preferences.vue'
import PointsManage from './components/points_manage.vue'
import ConsumptionRecords from './components/consumption_records.vue'
import {Bell,Coin, Document, Setting, User} from '@element-plus/icons-vue'
import EventBus from '@/utils/eventBus'
import {ElNotification} from "element-plus";
import i18n from "@/locales/i18n";
import {h as vueNode} from "vue";

export default {
  components: {
    User,
    Setting,
    Document,
    Coin,
    Bill,
    SubscriptionPurchase,
    Account_settings,
    Preferences,
    PointsManage,
    ConsumptionRecords
  },
  emits: [ 'payment-success'],
  data() {
    return {
      activeMenu: 'account_set',
      notificationTab: null,
      isClosingDueToDestroy: false
    }
  },
  computed: {
    menuItems() {
      return [
        {label: this.$t('views.account_center.account_center'), value: 'account_set', icon: 'User'},
        {label: this.$t('views.account_center.preferences'), value: 'preference_set', icon: 'Setting'},
        {label: this.$t('views.account_center.subscription_management'), value: 'subscription_manage', icon: 'Bell'},
        {label: this.$t('views.account_center.bill'), value: 'bill_manage', icon: 'Document'},
        {label: this.$t('views.account_center.consumption_records'), value: 'consumption_records', icon: 'Coin'}
      ]
    }
  },
  mounted() {
    this.eventBusHandler = (menu) => {
      this.activeMenu = menu;
      if (this.activeMenu === 'subscription_manage') {
        const hasNotification = localStorage.getItem('hasNotification');
        if(!hasNotification){
          this.getBrowserNotification();
        }
      }
    };
    EventBus.on('setActiveMenu', this.eventBusHandler);
  },
  beforeUnmount() {
    EventBus.off('setActiveMenu', this.eventBusHandler)
    if(this.notificationTab){
      this.isClosingDueToDestroy = true
      this.notificationTab.close()
    }
  },
  methods: {
    getBrowserNotification(){
      const self = this
      const browserPermission = () => {
        if (!('Notification' in window)) {
          return false;
        }
        return Notification.permission !== 'granted';
      }
      const showNotification = localStorage.getItem('showNotification');
      if(browserPermission() && showNotification === null) {
        this.isClosingDueToDestroy = false
        this.notificationTab = ElNotification({
          title: i18n.global.t('notification.bill_permission_box_title'),
          icon: vueNode(Bell, { style: { color: '#409EFF' } }),
          message: vueNode('div', null, [
            vueNode('p', null, i18n.global.t('notification.bill_permission_box_msg')),
            vueNode('p', {
              type: 'primary',
              size: 'small',
              style: {
                color: '#409EFF',
                cursor: 'pointer',
              },
              onClick: async () => {
                if (Notification.permission === 'denied') {
                  self.$message.primary(i18n.global.t('notification.permission_not_granted'));
                  localStorage.setItem('showNotification', 'false')
                  if (self.notificationTab) {
                    self.notificationTab.close()
                  }
                  return
                }
                const permission = await Notification.requestPermission();
                if (permission === 'granted') {
                  if (self.notificationTab) {
                    self.notificationTab.close();
                  }
                  localStorage.setItem('showNotification', 'false')
                } else {
                  if(permission === 'denied'){
                    self.$message.warning(i18n.global.t('notification.permission_denied'))
                  }
                  if (self.notificationTab) {
                    self.notificationTab.close();
                  }
                  localStorage.setItem('showNotification', 'false')
                }
              },
            }, i18n.global.t('notification.permission_box_btn'))
          ]),
          onClose: () => {
            if(!this.isClosingDueToDestroy){
              localStorage.setItem('showNotification', false);
            }
            this.notificationTab = null
            this.isClosingDueToDestroy = false
          },
          position: 'bottom-right',
          duration: 0
        })
      }
    },
    setActiveMenu(menu) {
      this.activeMenu = menu
      if(this.activeMenu === 'subscription_manage'){
        this.getBrowserNotification()
      }
    },
    handleSubscriptionPaymentSuccess(payload){
      this.$emit('payment-success', payload)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/views/account_center/index';
</style>
